import React, {useEffect, useRef, useState} from "react";
import {classNames} from "shared/lib/classNames/classNames";
//import {ReactComponent as Logo} from "shared/assets/icons/LigalTimesLogo.svg";
//import {AppLink} from "shared/ui/AppLink/AppLink";
import cls from "./Header.module.scss";
import {AppLink} from "shared/ui/AppLink/AppLink";
import Logo from "shared/assets/images/appIcon.png";


interface HeaderProps {
    className?: string
}

export const Header = ({className}: HeaderProps) => {
    const [headerOpen, setHeaderOpen] = useState(false);

    const menuRef = useRef<HTMLHeadElement>(null);

    const closeMenu = (e: any) => {
        if (e.target === menuRef.current) {
            setHeaderOpen((prevState) => !prevState);
            document.body.classList.toggle("with-open-menu");
        }
    }

    const onToggleMenu = (e: any) => {
        setHeaderOpen((prevState) => !prevState);
        document.body.classList.toggle("with-open-menu");
    }

    useEffect(() => {
        if (headerOpen) {
            menuRef.current?.addEventListener("click", closeMenu);
        }
        return () => menuRef.current?.removeEventListener("click", closeMenu);
    }, [headerOpen]);


    return (
        <header ref={menuRef} className={classNames(cls.header, {[cls.header_open]: headerOpen}, [className])}>
            <div className={classNames("container container__main", {}, [cls.header__container])}>
                <div className={cls.header__logo}>
                    <AppLink to={'/'}>
                        <div className={cls.Logo}>
                            <img src={Logo} alt="decoration"/>
                            {`Ai\nAstrology`}
                        </div>
                    </AppLink>
                </div>
            </div>
        </header>
    );
};
